import Phone from "phone";

export const ALLOW_COUNTRIES = ["US" as const, "CA" as const];

function validatePhone(value: string) {
    return ALLOW_COUNTRIES.some(country => {
        const check = Phone(value, {
            country: country.toLowerCase()
        });
        return check.isValid;
    });
}

export default validatePhone;
